import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import {
  Area,
  AreaChart,
  ResponsiveContainer,
} from "recharts";
import { colors } from "../../theme";

const PLACEHOLDER_POINTS = [
  { v: 2 },
  { v: 3 },
  { v: 2.5 },
  { v: 4 },
  { v: 3.5 },
  { v: 5 },
  { v: 4.5 },
];

const extractSeasonSeries = (seasons, statKey = "homeruns") => {
  if (!seasons || typeof seasons !== "object") return null;

  return Object.values(seasons)
    .filter((s) => s?.year && s[statKey] !== undefined && s[statKey] !== "")
    .sort((a, b) => Number(a.year) - Number(b.year))
    .slice(-8)
    .map((s) => ({
      v: Number(String(s[statKey]).replace(/[^\d.-]/g, "")) || 0,
    }));
};

/**
 * Mini sparkline for player cards.
 * Uses season HR data when available; placeholder until trending API (Phase 4).
 */
const PlayerSparkline = ({ seasons, statKey = "homeruns", positive = true }) => {
  const data = useMemo(
    () => extractSeasonSeries(seasons, statKey),
    [seasons, statKey]
  );
  const isPlaceholder = !data || data.length < 2;
  const chartData = isPlaceholder ? PLACEHOLDER_POINTS : data;
  const strokeColor = positive ? colors.positive : colors.negative;

  return (
    <Box sx={{ width: "100%", height: 36, position: "relative" }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={chartData} margin={{ top: 4, right: 0, left: 0, bottom: 0 }}>
          <Area
            type="monotone"
            dataKey="v"
            stroke={isPlaceholder ? colors.textSecondary : strokeColor}
            fill={isPlaceholder ? "transparent" : strokeColor}
            fillOpacity={isPlaceholder ? 0 : 0.15}
            strokeWidth={1.5}
            strokeDasharray={isPlaceholder ? "3 3" : undefined}
            dot={false}
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
      {isPlaceholder && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
            fontSize: "0.6rem",
            opacity: 0.7,
          }}
        >
          {/* TODO(Phase 4): Replace with trending API sparkline */}
          trend soon
        </Typography>
      )}
    </Box>
  );
};

export default PlayerSparkline;
